// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/receivables/sales',
        component: () =>
            import('@/pages/[organisation]/receivables/sales.vue'),
        name: 'accounts-receivable.sales.search-sales',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.sales.view-sales',
        },

        children: [
            {
                path: 'create-sale',
                component: () =>
                    import('@/pages/[organisation]/receivables/sales/create-sale.vue'),
                name: 'accounts-receivable.sales.create-sale',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales.create-sale',
                },
            },
            {
                path: ':id/update-sale',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales" */ '@/pages/[organisation]/receivables/sales/sale/[id]/edit.vue'),
                name: 'accounts-receivable.sales.update-sale',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales.update-draft-sale',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales" */ '@/pages/[organisation]/receivables/sales/sale/[id].vue'),
                name: 'accounts-receivable.sales.view-sale',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales.view-sales',
                },
            },
            {
                path: ':id/refund-sale',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales" */ '@/pages/[organisation]/receivables/sales/refund-sale.vue'),
                name: 'accounts-receivable.sales.refund-sale',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales.refund-sale',
                },
            },

            {
                path: ':id/history',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales" */ '@/pages/[organisation]/receivables/sales/sale-history.vue'),
                name: 'accounts-receivable.sales.view-sale-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales.view-sales',
                },
            },
        ],
    },
];
